import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { buildUrl } from 'utils';
import { cloneDeep } from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import { NestedDropdown } from 'components/UI';
import { AuthActions } from 'state/modules/auth';
import { userActions } from 'state/modules/user';
import { UserSettingsActions } from 'state/modules/userSettings';

export const UserOrgsDropdown = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [params, setParams] = useState({ limit: 10, page: 1 });

  const [service, setService] = useState('');
  const [servicesList, setServicesList] = useState([]);
  const loading = useSelector((state) => state.user?.fetchingUserOrganizations);
  const { list, pagination } = useSelector((state) => state.user?.organizations);
  const currentService = useSelector((state) => state.auth?.organizations?.current);

  const getUserOrganizations = useCallback(
    (params) => {
      dispatch(userActions.fetchUserOrganizations(params));
    },
    [dispatch]
  );

  /**
   * Set default organization/service
   * @param {object} currentService
   */
  const getDefaultOrganization = (currentService) => {
    setService(currentService?.name);
  };

  const filterOrgs = (arr) => {
    const formatedArray = arr
      .filter((e) => e?.organization_group?.name && e?.organization?.id !== currentService?.id)
      .map((value) => {
        return {
          name: value?.organization_group?.name + ' - ' + value?.organization?.name,
          ...value,
        };
      });
    return formatedArray;
  };

  const fetchMoreData = () => {
    if (pagination.nextPage && !loading) {
      setParams({
        ...params,
        page: pagination.currentPage + 1,
      });
    }
  };

  /**
   * Handle change of the select of services
   * @param {item}
   */
  const onChange = (item) => {
    const slug = item?.organization?.id_slug;
    setService(slug);
    // Set organization on sessionStorage
    sessionStorage.setItem('org_slug', slug);
    // Fetch user data with new organization
    dispatch(AuthActions.switchOrg());
    dispatch(AuthActions.fetchUserMe());
    history.replace(buildUrl('/dashboard', slug));
    // Reset Guiding Modal inital state
    dispatch(UserSettingsActions.handleShowGuidingModal('INIT'));
  };

  const onSearch = (query) => {
    if (!query) {
      return setServicesList(list);
    }
    const filteredItems = servicesList.filter((el) => {
      const name = el?.organization?.name?.toLowerCase();
      return name.includes(query);
    });

    setServicesList(filteredItems);
  };

  const onClose = () => {
    setServicesList(cloneDeep(list));
  };

  useEffect(() => {
    getDefaultOrganization(currentService);
  }, [currentService]);

  useEffect(() => {
    getUserOrganizations(params);
  }, [getUserOrganizations, params]);

  useEffect(() => {
    setServicesList(cloneDeep(list));
  }, [list]);

  useEffect(() => {
    const orgSlug = location.pathname.split('/')[1];
    if (orgSlug?.length > 0 && orgSlug !== currentService?.id_slug) {
      const currentOrg = list.find((service) => service?.organization?.id_slug === orgSlug);
      onChange(currentOrg);
    }
  }, [currentService, location]);

  return (
    <NestedDropdown
      label={service}
      onClose={onClose}
      loading={loading}
      onSearch={onSearch}
      handleClick={onChange}
      displayNameField="name"
      fetchMoreData={fetchMoreData}
      list={filterOrgs(servicesList)}
      hasMoreItems={pagination?.nextPage}
    />
  );
};
